import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_find_tasksService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { id?: number, orderId?: number, shipmentId?: number, statusId?: number, operationCodeId?: number, chainHead?: number, actualTargetLicensePlateId?: number, actualSourceLicensePlateId?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ChainHead?: number, MaterialId?: number, OperationCodeId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, StatusId?: number, WarehouseId?: number }[] }> 
  {
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_find_tasks/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { id?: number, orderId?: number, shipmentId?: number, statusId?: number, operationCodeId?: number, chainHead?: number, actualTargetLicensePlateId?: number, actualSourceLicensePlateId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ChainHead?: number, MaterialId?: number, OperationCodeId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, StatusId?: number, WarehouseId?: number }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_find_tasks/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { id?: number, orderId?: number, shipmentId?: number, statusId?: number, operationCodeId?: number, chainHead?: number, actualTargetLicensePlateId?: number, actualSourceLicensePlateId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, ActualSourceLicensePlateId?: number, ActualTargetLicensePlateId?: number, ActualTargetLocationId?: number, ChainHead?: number, MaterialId?: number, OperationCodeId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, ShipmentLineId?: number, StatusId?: number, WarehouseId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_find_tasks/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      id?: number, orderId?: number, shipmentId?: number, statusId?: number, operationCodeId?: number, chainHead?: number, actualTargetLicensePlateId?: number, actualSourceLicensePlateId?: number    }) {
      return false;
    }
}
